enum openFilePicker {
    ANY = '*/*',
    PDF = 'application/pdf',
    IMAGE = 'image/*',
    VIDEO = 'video/*',
    AUDIO = 'audio/*',
    MARKDOWN = '.md,.markdown,text/markdown,text/plain',
    TEXT = 'text/plain',
    DOC = '.doc,.docx,.odt,.rtf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    SPREADSHEET = '.xls,.xlsx,.ods,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv',
    PRESENTATION = '.ppt,.pptx,.odp,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
    PDF_AND_OFFICE = 'application/pdf,.doc,.docx,.odt,.xls,.xlsx,.ods',
    COMPRESSED = 'application/zip, application/x-rar-compressed, application/x-7z-compressed, application/gzip',
    DRAWING = '.odg',
    CSV = '.csv,text/csv'
}

export default openFilePicker;